import { camelObject } from '@/utils/common';

// Mapping data to convert it to camelCase
export function transformerArray(payload: Record<string, any>[]): any {
  return payload.map((item: any) => camelObject(item));
}

export function transformerObject(payload: Record<string, any>): any {
  return camelObject(payload);
}
